module.exports = __webpack_public_path__ + "jQueryPostit.svg?150376365ac928aa75a167abd91d7100";